var _defs, _path, _use, _use2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVaccine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    fill: "none",
    d: "M0 0h36v36H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.5,
    d: "M28.23 9.488a1.115 1.115 0 0 1 0 1.579l-.791.79.791.79a2.234 2.234 0 0 1 0 3.159L16.387 27.644a2.232 2.232 0 0 1-3.159 0l-.79-.79-3.157 3.16 1.578 1.58a1.1165216 1.1165216 0 0 1-1.579 1.579l-6.316-6.318a1.116 1.116 0 1 1 1.575-1.579l1.579 1.579a23.025 23.025 0 0 0 3.159-3.157c.592-.987-.79-.79-.79-.79a2.231 2.231 0 0 1 0-3.157L20.339 7.908a2.231 2.231 0 0 1 3.157 0l.79.79.79-.79a1.115 1.115 0 0 1 1.579 0l.395.395 6.317-6.317v1.578l-5.528 5.527.395.4Zm-5.527-.79a1.115 1.115 0 0 0-1.579 0l-2.369 2.369-.79.79-2.369 2.369-.791.79-.79.79-.79.79-2.366 2.365-.79.79-.79.79a1.115 1.115 0 0 0 0 1.579l4.737 4.737a1.115 1.115 0 0 0 1.58 0l11.843-11.842a1.113 1.113 0 0 0 0-1.579l-4.736-4.738Zm-3.157 1.579.79-.79Zm-3.158 3.157.79-.79Zm-4.739 4.738.79-.79Z"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVaccine);
export default __webpack_public_path__ + "static/media/vaccine.047bb98dff03f5c89c4a8984680d17fd.svg";
export { ForwardRef as ReactComponent };